module.exports = __webpack_public_path__ + "static/media/trening.a92a0b82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/trening.jpg
// module id = 5745
// module chunks = 0